export const HOME = '/'
export const EDIT = '/edit'
export const VIEW = '/view'
export const DASHBOARD = '/dashboard'
export const PREVIEW = '/preview'
export const FORM = '/form'
